import { plainToInstance, Type } from 'class-transformer';
import { IsArray, IsIn, IsNotEmpty, IsNumber, IsOptional } from 'class-validator';
import { DownloadFileDto } from './download-file.dto';
import { InvoiceRowDto } from './invoice-row.dto';
import { InvoiceDto } from './invoice.dto';
import { UserDto } from './user.dto';
import { PURCHASE_STATUSES } from './enums/purchase-statuses';

export class PurchaseInfoDto {
  @IsNumber()
    id: number;

  invoiceScan: DownloadFileDto[];

  bankDetailsScan: DownloadFileDto[];

  wccScan: DownloadFileDto[];

  promoScan: DownloadFileDto[];
  photoProof: DownloadFileDto[];

  status: PurchaseStatusDto;

  clientInvoiceRow: InvoiceRowDto;

  clientInvoice: InvoiceDto;

  supplierInvoiceRow: InvoiceRowDto;

  supplierInvoice: InvoiceDto;

  manager: UserDto;

  createdAt: Date;

  paymentAmount?: number;
  paymentDate?: Date;

  static fromPlain(obj: any) {
    return plainToInstance<PurchaseInfoDto, any>(PurchaseInfoDto, obj, { enableImplicitConversion: true });
  }
}

export class UpdatePurchaseDto {
  @IsNumber()
  @Type()
    id: number;

  @Type()
  @IsNumber()
    statusId: number;

  invoiceScan: DownloadFileDto[];
  bankDetailsScan: DownloadFileDto[];

  wccScan: DownloadFileDto[];
  promoScan: DownloadFileDto[] | null;
  photoProof: DownloadFileDto[] | null;
}

export class PurchaseWccWarningDto {
  purchaseId: number;
  message: string;
}

export class PurchaseStatusUpdateResultDto {
  updatedCount: number;
  wccWarnings: PurchaseWccWarningDto[];
}

export class PurchaseDto extends PurchaseInfoDto {
  wccWarnings?: PurchaseWccWarningDto[];
}

export class CreatePurchaseDto {
  @IsNumber()
  @IsNotEmpty()
    clientInvoiceRowId: number;
}

export class UnlinkSupplierDto {
  @IsNumber()
    id: number;
}

export class LinkSupplierDto {
  @IsNumber()
    purchaseId: number;

  @IsNumber()
    invoiceRowId: number;
}

export class CreatePayOrderFromPurchaseDto {
  amount: number;
}

export class PurchaseStatusDto {
  id: number;
  label: string;
}

export class PurchaseStatusCheckDto {
  @IsIn(PURCHASE_STATUSES.map((x) => x.id))
    status: number;
  @IsArray()
  ids: number[];
}

export class UpdatePurchaseStatusDto {
  @IsIn(PURCHASE_STATUSES.map((x) => x.id))
    status: number;
  @IsOptional()
  id: number;
  @IsOptional()
  @IsArray()
  ids?: number[];
}
